import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBox, FaBoxOpen, FaCalendarAlt, FaCashRegister, FaChartLine, FaCog, FaEdit, FaEllipsisH, FaEnvelope, FaEye, FaFileDownload, FaFilePdf, FaFileUpload, FaInvision, FaList, FaMapMarkerAlt, FaMoneyBillWave, FaPlus, FaPrint, FaQrcode, FaReceipt, FaSearch, FaStore, FaTag, FaTh, FaTrash, FaUser, FaWhatsapp } from 'react-icons/fa';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Table, Toast, ToastBody, ToastHeader } from 'reactstrap';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { productActions } from '../../sagas/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { saleActions } from '../../sagas/saleSlice';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import { purchaseActions } from '../../sagas/purchaseSlice';
import { PURCHASES_PAGE } from '../../routes/routeConstants';
import { formatPrice } from '../../helpers/utility';
const BuysReport = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [criteria, setSearchCriteria] = useState({ query: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const { t } = useTranslation();
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const {
        purchases,
        isLoading,
        lines
    } = useSelector((state) => state.purchases);
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [selectedSale, setSelectedSale] = useState(null);
    const { businessName, email, address, telephone, fullName } = useSelector(state => state.auth);
    const navigate = useNavigate();
    const [showActions, setShowActions] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [displayMode, setDisplayMode] = useState('details'); // or 'achats'
    const searchInputRef = useRef(null);
    const [totalPurchaseAmount, setTotalPurchaseAmount] = useState(0);

    // Add handler
    const handleViewDetails = (purchase) => {
        setSelectedSale(purchase);
        setShowReceiptModal(true);
    };


    useEffect(() => {
        console.log(startDate)
        let payload = {
            startDate: startDate,
            endDate: endDate,
            query: searchTerm
        };

        if (displayMode === 'achats') {
            dispatch(purchaseActions.search(payload));
        } else {
            dispatch(purchaseActions.filterLines(payload));
        }

    }, [startDate, endDate, displayMode]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        if( lines && lines.length > 0) {
            const totalAmount = lines.reduce((sum, item) => sum + (item.price * item.quantity), 0);
            setTotalPurchaseAmount(totalAmount);
        }else if(purchases && purchases.length > 0) {
            const totalAmount = purchases.reduce((sum, item) => sum + item.totalAmount, 0);
            setTotalPurchaseAmount(totalAmount);
        }else{
            setTotalPurchaseAmount(0);
        }
        
        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);

        
    }, [lines, purchases]);


    // Debounced search function


    const debouncedSearch =
        debounce((query) => {
            if (displayMode === 'achats') {
                dispatch(purchaseActions.search({
                    startDate: startDate,
                    endDate: endDate,
                    query,
                    onSuccess: () => {
                        searchInputRef.current?.focus();
                    }
                }));
            } else {
                dispatch(purchaseActions.filterLines({
                    startDate: startDate,
                    endDate: endDate,
                    query,
                    onSuccess: () => {
                        searchInputRef.current?.focus();
                    }
                }));
            }

        }, 1500);

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (value.length > 5 || value.length === 0) {
            debouncedSearch(value);
        }
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            debouncedSearch(searchTerm); // Trigger search when Enter is pressed
        }
    };

    const mapSaleToDTO = (sale) => {
        return {
            id: sale.supplierId,
            description: sale.supplierName,
        };
    };

    const handleGeneratePdf = (sale) => {
        debugger
        const saleDTO = mapSaleToDTO(sale);
        dispatch(purchaseActions.generatePdfRequest(saleDTO));
    };


    const handlePrint = () => {
        const element = document.getElementById('receipt-content');
        html2canvas(element).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.autoPrint();
            window.open(pdf.output('bloburl'), '_blank');
        });
    };

    const DisplayToggle = () => (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="btn-group">
                <Button
                    color={displayMode === 'details' ? 'primary' : 'light'}
                    onClick={() => {setDisplayMode('details')
                        searchInputRef.current?.focus();
                        setSearchTerm('');
                    }}
                    size="sm"
                >
                    <FaList className="me-1" /> {t('common.details')}
                </Button>
                <Button
                    color={displayMode === 'achats' ? 'primary' : 'light'}
                    onClick={() => {
                        setDisplayMode('achats');
                        searchInputRef.current?.focus();
                        setSearchTerm('');
                    }}
                    size="sm"
                >
                    <FaTh className="me-1" /> {t('common.achats')}
                </Button>
            </div>
        </div>
    );

    const AchatsView = () => (
        <>
            <Table hover bordered className="align-middle mb-0">
                <thead className="bg-light">
                    <tr>
                        <th className="align-middle">
                            <FaReceipt className="me-2 text-primary" size={12} />
                            {t('buy.numeroPurchase')}
                        </th>
                        <th className="align-middle">
                            <FaBox className="me-2 text-primary" size={12} />
                            {t('buy.date')}
                        </th>
                        <th className="align-middle text-center">
                            <FaUser className="me-2 text-primary" size={12} />
                            {t('buy.supplier')}
                        </th>
                        <th className="align-middle text-center">
                            <FaTag className="me-2 text-primary" size={12} />
                            {t('buy.total')}
                        </th>

                        <th className="align-middle text-center" style={{ width: '120px' }}>
                            <FaCog className="me-2 text-primary" size={12} />
                            {t('common.actions')}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {!purchases || purchases.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center py-4">
                                <div className="text-muted">
                                    {t('buy.noAchats')}
                                </div>
                            </td>
                        </tr>
                    ) : (
                        purchases.map((purchase) => (
                            <tr key={purchase.id}>
                                <td className="align-middle">{purchase.numero}</td>
                                <td className="align-middle">{purchase.createdAt}</td>
                                <td className="align-middle text-center">{purchase.supplierDescription}</td>
                                <td className="align-middle text-center">{formatPrice(purchase.totalAmount)}</td>
                                <td className="align-middle text-center">
                                    <div className="d-flex gap-1 justify-content-center">
                                        <Button
                                            color="info"
                                            size="sm"
                                            className="px-2 py-1"
                                            onClick={() => handleViewDetails(purchase)}
                                        >
                                            <FaMoneyBillWave size={12} />
                                        </Button>
                                    </div>

                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </>
    );



    const DetailsView = () => (
        <>
            <Table hover bordered className="align-middle mb-0">
                <thead className="bg-light">
                    <tr>
                        <th>{t('buy.orderNumber')}</th>
                        <th>{t('buy.orderDate')}</th>
                        <th>{t('product.barcode')}</th>
                        <th>{t('product.description')}</th>
                        <th>{t('product.quantity')}</th>
                        <th>{t('buy.prixAchat')}</th>
                        <th>{t('buy.supplier')}</th>
                    </tr>
                </thead>
                <tbody>
                    {!lines || lines.length === 0 ? (
                        <tr>
                            <td colSpan="8" className="text-center py-4">
                                <div className="text-muted">
                                    {t('buy.noAchats')}
                                </div>
                            </td>
                        </tr>
                    ) : (
                        lines.map((item) => (
                            <tr key={item.id}>
                                <td className="align-middle">{item.orderNumber}</td>
                                <td className="align-middle">{item.orderDate}</td>
                                <td className="align-middle">{item.productBarcode}</td>
                                <td className="align-middle">{item.productDescription}</td>
                                <td className="align-middle">{item.quantity}</td>
                                <td className="align-middle text-end">{formatPrice(item.price)}</td>
                                <td className="align-middle">{item.supplierDescription}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </>
    );

    return (
        <Container fluid>
            <Row className="mb-3">
                <Col>
                    <Card className="shadow-sm border-0">
                        <CardBody className="py-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <h4 className="mb-0 d-flex align-items-center">
                                    <FaChartLine className="text-primary me-2" />
                                    {t('buy.pageTitle')}
                                </h4>
                                <Button
                                    color="primary"
                                    className="d-flex align-items-center"
                                    onClick={() => navigate(PURCHASES_PAGE)}
                                    title={t('buy.newPurchase')}
                                >
                                    <FaPlus className="me-2" />
                                    {t('buy.newPurchase')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="pe-4">
                    <Card className="shadow-sm h-100">
                        <CardBody>
                            {isLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">{t('common.loading')}</span>
                                    </div>
                                    <div className="mt-2 text-muted">
                                        {t('common.loadingData')}
                                    </div>
                                </div>
                            ) : (<>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    {/* Search Input - Left Side */}
                                    <div className="position-relative flex-grow-1 me-3">
                                        <Input
                                            innerRef={searchInputRef}
                                            type="text"
                                            placeholder={t('buy.searchPlaceholder')}
                                            value={searchTerm}
                                            onKeyDown={handleSearchKeyDown}
                                            onChange={handleSearchChange}
                                            className={`ps-4 pe-5 ${isSearching ? 'searching' : ''}`}
                                        />
                                        <FaSearch
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '12px',
                                                color: '#6c757d'
                                            }}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <FormGroup className="me-3">
                                            <Label for="startDate">{t('sale.startDate')}</Label>
                                            <Input
                                                type="date"
                                                id="startDate"
                                                value={startDate.toISOString().split('T')[0]}
                                                onChange={(e) => setStartDate(new Date(e.target.value))}
                                                className="form-control"
                                            />
                                        </FormGroup>
                                        <FormGroup className="me-3">
                                            <Label for="endDate">{t('sale.endDate')}</Label>
                                            <Input
                                                type="date"
                                                id="endDate"
                                                value={endDate.toISOString().split('T')[0]}
                                                onChange={(e) => setEndDate(new Date(e.target.value))}
                                                className="form-control"
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                                <DisplayToggle />
                                <div className="table-responsive" style={{ overflowY: 'auto', maxHeight: '450px' }}>
                                    {displayMode === 'achats' ? <AchatsView /> : <DetailsView />}
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    <h5>{t('buy.totalPurchasesAmount')}: {formatPrice(totalPurchaseAmount)}</h5>
                                </div>

                            </>)}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal isOpen={showReceiptModal} toggle={() => setShowReceiptModal(false)} size='lg'>
                <ModalHeader toggle={() => setShowReceiptModal(false)}>
                    {t('buy.purchaseDetails')}
                </ModalHeader>
                <ModalBody>
                    <div
                        id="receipt-content"
                        className="p-4 bg-white shadow-sm rounded"
                        style={{ width: '100%' }}
                    >
                        {/* Header */}
                        <div className="text-center mb-4">
                            <h5 className="mb-2">
                                <FaStore className="me-2 text-secondary" />
                                {businessName}
                            </h5>
                            <small className="d-block mb-2">
                                <FaMapMarkerAlt className="me-1 text-secondary" />
                                {address}
                            </small>
                            <div className="d-flex justify-content-center align-items-center gap-3">
                                {telephone && (
                                    <small>
                                        <FaWhatsapp className="me-1 text-secondary" />
                                        {telephone}
                                    </small>
                                )}
                                <small>
                                    <FaEnvelope className="me-1 text-secondary" />
                                    {email}
                                </small>
                            </div>
                        </div>

                        <hr />

                        {/* Receipt Details */}
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div>
                                    <FaReceipt className="me-2 text-secondary" />
                                    <span className="fw-bold">{t('buy.numeroPurchase')}: </span>
                                    {selectedSale?.numero}
                                </div>
                                <div>
                                    <FaCalendarAlt className="me-2 text-secondary" />
                                    <span className="fw-bold">{t('buy.date')}: </span>
                                    {selectedSale?.createdAt}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-2">

                                <div>
                                    <FaUser className="me-2 text-secondary" />
                                    <span className="fw-bold">{t('buy.supplier')}: </span>
                                    {selectedSale?.supplierDescription}
                                </div>
                            </div>
                        </div>

                        <hr />

                        {/* Products Table */}
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>{t('product.description')}</th>
                                    <th className="text-end">{t('receipt.price')}</th>
                                    <th className="text-end">{t('receipt.quantity')}</th>
                                    <th className="text-end">{t('receipt.total')}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {selectedSale && selectedSale.lines.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.productDescription}</td>
                                        <td className="text-end">{formatPrice(item.price)}</td>
                                        <td className="text-end">{item.quantity}</td>
                                        <td className="text-end">{formatPrice(item.price * item.quantity)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <hr />

                        {/* Totals */}
                        <div className="text-end mb-4">
                            <div className="mb-2">
                                <span className="fw-bold me-3">{t('buy.total')}:</span>
                                {formatPrice(selectedSale?.totalAmount)}
                            </div>

                        </div>


                    </div>
                </ModalBody>
                {/* <ModalFooter>
                    <Button color="primary" onClick={handlePrint}>
                        <FaPrint className="me-1" />
                        {t('receipt.printBill')}
                    </Button>
                </ModalFooter> */}
            </Modal>
        </Container>

    );
};

export default BuysReport;
